import { createFileRoute } from "@tanstack/react-router";

import { financialExplorerSearchSchema } from "@/features/financial-explorer/lib/explorer-search";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_client-tabs/financial-explorer",
)({
  validateSearch: financialExplorerSearchSchema,
});
